import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, onUnmounted, ref} from "vue";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute} from "vue-router";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {BooleanColumn, DateTimeColumn, DefaultColumn, MoneyColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import {useNavigationStore} from "@/modules/Navigation/store";
import {Api} from "@/shared/services/api";
import apiOrder from "@/modules/Order/api";
import apiFile from "@/shared/services/apiFile";
import {computed} from "vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import {IdType} from "@/shared/model/idType";



export default /*@__PURE__*/_defineComponent({
  __name: 'OrderListComponent',
  emits: ["selected"],
  setup(__props, { expose: __expose, emit: __emit }) {

const _emit = __emit


const _grid = ref<InstanceType<typeof SogGrid> | null>(null)
const _url = Api.baseUrl + '/OrderList';

const _accountStore = useAccountStore();
const {isBranch} = storeToRefs(_accountStore)
const _isPriceVisible = computed(() => {
  return !(isBranch.value)
})


const _columnsOrder: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  {
    ...DefaultColumn, headerText: '', visible: true, commands: [
      {
        buttonOption: {cssClass: 'e-flat', iconCss: 'e-circle-info e-icons', click: onClickDetails}
      },
      /*
            {
              buttonOption: { cssClass: 'e-flat', iconCss: 'e-print e-icons',  click:onClickPdf},
            },
      */
    ], textAlign: 'Left', uid: 'details', width: 60
  },
  {...DefaultColumn, field: 'id', headerText: 'id', isPrimaryKey: true, visible: true},
  {...DefaultColumn, field: 'orderNumber', headerText: 'Nummer', filter: {type: 'CheckBox'}},
  {...DefaultColumn, field: 'personName', headerText: 'Besteller'},
  {...DefaultColumn, field: 'supplierName', headerText: 'Bestellt bei'},
  {...MoneyColumn, field: 'orderAmount', headerText: 'Betrag,€', visible: _isPriceVisible.value},
  {...DateTimeColumn, field: 'orderedDate', headerText: 'Datum'},
  {...BooleanColumn, field: 'invoiced', headerText: 'Abgerechnet', width: 50},
  {...DefaultColumn, field: 'orderedByPersonName', headerText: 'Bestellt durch'},

]

const _columns = _columnsOrder
const _buttonId = ref("");
const _navigationStore = useNavigationStore();
const _sector = ref("");
const _type = ref("");
const _filterType = ref("");
const _spinner = useSpinner();
//const _adaptor = ref<CustomAdaptor|undefined>(undefined)

const _adaptor = computed(() => {
  return _grid?.value.adaptor
})


function p_init(route: RouteLocationNormalizedLoaded) {
  _sector.value = route.params.sector as string;
  _type.value = route.params.type as string;
  _filterType.value = route.params.filtertype as string;
  _grid.value?.adaptor.removePredicate("sector");
  _grid.value?.adaptor.addPredicate("sector", "equal", _sector.value);
  _grid.value?.adaptor.removePredicate("Type");
  _grid.value?.adaptor.removePredicate("personid");

  _grid.value?.hideColumns("id")
  let t_col = _grid.value?.getColumnByField("paid")
  if (!t_col) {
    t_col = _grid.value?.getColumnByField("invoiced")
  }

  if (_sector.value === "sale") {
    _grid.value?.showColumns("Besteller")
    _grid.value?.hideColumns("Bestellt bei")
  } else {
    _grid.value?.showColumns("Bestellt bei")
    _grid.value?.hideColumns("Besteller")
  }

  if (_type.value === "Order") {
    t_col.field = "invoiced"
    t_col.headerText = "Abgerechnet"
//    _columns.value = sector==="sale"?_columnsSaleOrder:_columnsOrder;
    _grid.value?.adaptor.addPredicate("Type", "equal", "Order",);
  } else {
    t_col.field = "paid"
    t_col.headerText = "Bezahlt"
//    _columns.value = sector==="sale"?_columnsInvoiceSale:_columnsInvoice;
    _grid.value?.adaptor.addPredicate("Type", "notequal", "Order",);
  }

  if (_filterType.value === "person" && _navigationStore.currentPersonId) {
    _grid.value?.adaptor.addPredicate("personid", "equal", _navigationStore.currentPersonId);
  }

  //_grid.value?.refreshColumns();
  //_grid.value?.refresh();
}

onUnmounted(() => {
  //console.log("onUnmounted")
})

onMounted(() => {
  const route = useRoute()
  p_init(route);
})

onBeforeRouteUpdate((to) => {
  p_init(to);
})

async function onClick(args: any) {
  _navigationStore.currentOrderNumber = args.rowData.orderNumber
  if (_buttonId.value === "details") {
    await _navigationStore.showObject(IdType.Order, args.rowData.id)
  } else if (_buttonId.value === "pdf") {
    try {
      _spinner.show();
      const id = await apiOrder.orderInitPdf(args.rowData.id)
      if (id) {
        await apiFile.downloadFile(id)
      }
    } finally {
      _spinner.hide()
    }
  }

}

function onClickDetails() {
  _buttonId.value = "details"
}


function onRowSelected(args: any) {
  _navigationStore.currentOrderNumber = args.data.orderNumber
  _emit("selected", args.data)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _navigationStore.currentOrderNumber = undefined
  _emit("selected", undefined)
}

function refresh() {
  _grid.value?.refresh()
}

function excelExport() {
  _grid.value?.excelExport()
}


__expose({
  adaptor: _adaptor, refresh, excelExport
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogGrid, {
    ref_key: "_grid",
    ref: _grid,
    url: _url,
    columns: _unref(_columns),
    "on-command-click": onClick,
    width: "auto",
    "on-row-selected": onRowSelected,
    "on-row-deselected": onRowDeselected,
    "allow-excel-export": true,
    "refresh-on-mount": false
  }, null, 8, ["columns"]))
}
}

})